export const productHeaderStandardGql = /* GraphQL */ `
... on bodyContent2022_headerStandard_BlockType {
    typeHandle
    theme
    alignment
    subtitle
    sectionTitle
    description
    mediaSize
    maxHeight
    links:bcProductHeaderStandardLinks {
        ... on bcProductHeaderStandardLinks_BlockType {
            linkStyle:bcProductHeaderStandardLinkLinkStyle
            enableModal:bcProductHeaderStandardLinksEnableModal
            disclaimerFootnote:bcProductHeaderStandardLinksDisclaimerFootnote {
                ... on disclaimerFootnote_disclaimerFootnote_Entry {
                    content:disclaimercontent
                }
            }
            link:bcProductHeaderStandardLink {
                ariaLabel
                customText
                url
                target
                text
                element {
                    title
                    ... on videos_Asset {
                        videoId
                        videoSource
                    }
                    ... on videoUploads_Asset {
                        videoUrl:url
                    }
                }
            }
        }
    }
    media {
        ... on images_Asset {
            title
            uncropped1920w {
                srcset
                srcWebp
            }
        }
    }
}`;
